import React from 'react'
import OrderRetailCreateContainer from 'containers/panel/reseller/order-retail-create-container'
const OrderRetailCreatePage = () => {
  return (
    <OrderRetailCreateContainer/>
  )
}

export default OrderRetailCreatePage